export default __webpack_public_path__ + "static/media/icons-menu-setting.018ef92d.svg";